module.exports = __webpack_public_path__ + "img/export.7660b4cb.svg";